import * as React from "react";
import { withStyles, WithStyles, Theme, withTheme, WithTheme, createStyles, StyleRulesCallback } from "../mui/styles";
import { CircularProgress, Fade } from "../widget";

export interface DataGridSpinnerProps
{
    loading: boolean;
    delay?: number;
}

declare type Props = DataGridSpinnerProps & WithStyles<typeof styles>;

class DataGridSpinner extends React.PureComponent<Props> {

    render()
    {

        const { classes, loading, delay } = this.props;

        return loading && <div className={classes.root}>
            <Fade in={loading} style={{ transitionDelay: loading ? `${delay || 500}ms` : '0ms', }} unmountOnExit>
                <CircularProgress size={24} thickness={4} disableShrink variant="indeterminate" className={classes.spinner} />
            </Fade>
        </div>;
    }
}

const styles = ((theme: Theme) =>
{

    return createStyles({

        root: {
            position: 'absolute',
            width: '100%',
            height: '100%',
            zIndex: 1000,
        },

        spinner: {
            color: theme.palette.secondary.main,
            left: '50%',
            top: '50%',
            position: 'absolute',
            animationDuration: '550ms',
        },


    })
}) as StyleRulesCallback;

export default withStyles(styles, { name: 'DataGridSpinner' })(DataGridSpinner);
